import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GoogleplayBtnComponent } from './button.component';
import { ANDROID_APP_LINK } from '@src/app/core/constants';

@NgModule({
  declarations: [GoogleplayBtnComponent],
  exports: [GoogleplayBtnComponent],
  imports: [
    CommonModule,
  ]


})
export class GoogleplayBtnModule { }
